import { render, staticRenderFns } from "./SideOverlay.vue?vue&type=template&id=b2f3170a"
import script from "./SideOverlay.vue?vue&type=script&lang=js"
export * from "./SideOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/julie/Works/openmetacity/Meta_Land-Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2f3170a')) {
      api.createRecord('b2f3170a', component.options)
    } else {
      api.reload('b2f3170a', component.options)
    }
    module.hot.accept("./SideOverlay.vue?vue&type=template&id=b2f3170a", function () {
      api.rerender('b2f3170a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/partials/SideOverlay.vue"
export default component.exports